import { useCallback, useState } from 'react';
import EditablePicker, { Props } from '@sdk/components/forms/EditablePicker';

const EditablePickerWithDefault = (props: Props) => {
  const { onChange, onFocusChange } = props;
  const [value, setValue] = useState(props.value);
  const handleChange = useCallback(
    (val) => {
      setValue(val);
      onChange?.(val);
    },
    [onChange]
  );
  const handleFocusChange = useCallback(
    (focused) => {
      if (focused) {
        setValue(null);
      }
      onFocusChange?.(focused);
    },
    [onFocusChange]
  );

  return (
    <EditablePicker
      {...props}
      value={value}
      onFocusChange={handleFocusChange}
      onChange={handleChange}
      forceOptionSelection
    />
  );
};

export default EditablePickerWithDefault;
